export default "__VITE_ASSET__Ba7vxlnW__"